export const FETCH_METAL_TYPE_REQUEST = 'FETCH_METAL_TYPE_REQUEST';
export const FETCH_METAL_TYPE_SUCCESS = 'FETCH_METAL_TYPE_SUCCESS';
export const FETCH_METAL_TYPE_FAILURE = 'FETCH_METAL_TYPE_FAILURE';

export const ADD_METAL_TYPE_REQUEST = 'ADD_METAL_TYPE_REQUEST';
export const ADD_METAL_TYPE_SUCCESS = 'ADD_METAL_TYPE_SUCCESS';
export const ADD_METAL_TYPE_FAILURE = 'ADD_METAL_TYPE_FAILURE';

export const UPDATE_METAL_TYPE_REQUEST = 'UPDATE_METAL_TYPE_REQUEST';
export const UPDATE_METAL_TYPE_SUCCESS = 'UPDATE_METAL_TYPE_SUCCESS';
export const UPDATE_METAL_TYPE_FAILURE = 'UPDATE_METAL_TYPE_FAILURE';

export const DELETE_METAL_TYPE_REQUEST = 'DELETE_METAL_TYPE_REQUEST';
export const DELETE_METAL_TYPE_SUCCESS = 'DELETE_METAL_TYPE_SUCCESS';
export const DELETE_METAL_TYPE_FAILURE = 'DELETE_METAL_TYPE_FAILURE';

export const METAL_TYPE_FORM_ERROR = 'METAL_TYPE_FORM_ERROR';
export const METAL_TYPE_FORM_SUCCESS = 'METAL_TYPE_FORM_SUCCESS';
export const SET_METAL_TYPE_EDIT = 'SET_METAL_TYPE_EDIT';
export const CLEAR_METAL_TYPE_EDIT = 'CLEAR_METAL_TYPE_EDIT'; 